import { RouteObject } from 'react-router-dom';
import { reviewRoutes, legacyRoutes } from './reviewRoutes';
import { appRoutes, dashboardRoutes } from './appRoutes';

/**
 * Main route configuration
 * Combines all route modules into a single configuration
 */
export const routes: RouteObject[] = [
  ...reviewRoutes,
  ...legacyRoutes,
  ...dashboardRoutes,
  ...appRoutes // Keep app routes last for catch-all to work properly
];

/**
 * Route constants for type-safe navigation
 * Ultra-simplified structure with just appointment codes - steps managed via history state
 */
export const ROUTES = {
  // Review workflow - ultra-simplified structure (steps in history.state)
  REVIEW: '/:code',
  
  // App
  ROOT: '/',
  RATINGS: '/ratings'
} as const;

/**
 * Helper functions for generating route paths
 * Ultra-simplified URL structure with appointment codes only
 */
export const generatePath = {
  review: (appointmentId: string) => `/${appointmentId}`
};

/**
 * Step constants for use with history.state
 */
export const REVIEW_STEPS = {
  ADD: 'add',
  NEGATIVE: 'negative', 
  TIPPING: 'tip',
  PAYMENT: 'payment',
  THANK_YOU: 'thank-you',
  DONE: 'done',
  TIP_TECH: 'tip-tech'
} as const;
